import React, { Component } from 'react';
import axios from 'axios';
import ApplicationView from './ApplicationView';
import { Grid, Card, CardContent, Box, Typography } from '@material-ui/core';

import { normalizeRegionFullname, normalizeDistrict } from '../functions/normalize';
import { getCommunityApplyInfo } from '../functions/community-operations';

import ExcelExport from '../buttons/ApplicationExcelExport';

class ApplicatingCommunities extends Component {
  state = { array: null, total: 0, error: null };

  async componentDidMount() {
    try {
      const data = await axios.get('/stat/allreq');
      // console.log('applications:', JSON.stringify(data.data));

      const arrayOfRegions = data.data;
      const array = [];
      let total = 0;

      arrayOfRegions.forEach((region) => {
        const currentRegion = {
          regionName: normalizeRegionFullname(region.reg.name),
          districts: [],
        };

        const currentDistricts = region.districts;

        currentDistricts.forEach((district) => {
          let districtName = normalizeDistrict(district.dist.name);
          if (!districtName.includes('м.')) districtName += ' район';

          const currentDistrict = {
            districtName: districtName,
            communities: [],
          };

          const currentCommunities = district.communities;

          total += currentCommunities.length;

          currentCommunities.forEach((community) => {
            const currentCommunity = getCommunityApplyInfo(community);
            currentDistrict.communities.push(currentCommunity);
          });

          currentRegion.districts.push(currentDistrict);
        });

        array.push(currentRegion);
      });

      this.setState({ array, total });

      const listOfRegions = [];

      arrayOfRegions.forEach((region) => {
        listOfRegions.push(normalizeRegionFullname(region.reg.name));
      });

      listOfRegions.sort((a, b) => a.localeCompare(b));

      this.setState({ regions: listOfRegions });
    } catch (error) {
      console.log('error:', error);
      this.setState({ error });
    }
  }

  render() {
    const { array, total, error } = this.state;
    const card = { minWidth: '100%', border: '1px solid #283f71', paddingBottom: 80 };
    const centered = { width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' };

    if (error) return null;

    return (
      // <div>HELLO APPLICATIONS</div>
      <Card>
        <Box width="100%">
          <CardContent style={card}>
            <Grid container direction="column">
              <Grid item xs={12}>
                <Grid container direction="row" justify="center" alignItems="center">
                  <Grid item xs={12} style={centered}>
                    <Typography
                      style={{ color: '#2B4458', marginBottom: '50px', textAlign: 'center', fontSize: 24 }}
                      variant="h3"
                      gutterBottom
                    >
                      Успішні електронні заяви на підключення
                      <br />
                      до ПК «ІІС «Соціальна громада»
                    </Typography>
                  </Grid>
                </Grid>

                <Grid container direction="row" justify="center" alignItems="center">
                  <Grid item xs={12} style={centered}>
                    <ExcelExport dataSet={array} />
                  </Grid>
                </Grid>

                <Grid container direction="row" justify="center" alignItems="center">
                  <Grid item xs={12} style={centered}>
                    <div style={{ maxHeight: 500, overflow: 'auto' }}>
                      {array && <ApplicationView array={array} total={total} />}
                    </div>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Box>
      </Card>
    );
  }
}

export default ApplicatingCommunities;
